

	import { Component, Prop } from 'vue-property-decorator';
	import { PropType } from 'vue';
	import { BaseView } from '@shared/views/BaseView';
	import { Deck, DeckSearchRequest, PagedResult, Series } from '@shared/models';
	import DeckItemList from '@client/views/products/decks/DeckItemList.vue';

	@Component({
		components: {
			DeckItemList,
		},
	})
	export default class OtherDecksInSeries extends BaseView {

		@Prop({ type: Object as PropType<Deck> })
		public model: Deck;
		public list: Series[] = [];

		public async mounted() {
			try {
				if (!this.model.series?.length) { return; }
				for (const series of this.model.series) {
					const request = new DeckSearchRequest({ seriesIds: series.id, sortBy: 'createdDate', sortDirection: 'desc', pageSize: 60 });
					const response = await this.$api.deckService.search(request);
					series.decks = response;
					this.list.push(series);
				}
			} catch (err) {
				this.errorMessage = 'An error occurred while getting other decks in this series';
				this.errorHandler.handle(err, this.errorMessage);
			}
		}

	}
